"use client";

import useSWR from "swr";
import { getPage } from "../sanity/client";
import styles from "../layout.module.css";
import CustomContent from "../components/customContent";

export default function GetInvolved() {
  const { data: content } = useSWR("page-get-involved", () =>
    getPage("get-involved").then((r: any) => r[0].content)
  );

  return (
    <>
      <h1 className="font-bold text-3xl mb-4">Get Involved</h1>

      <div className={styles.popLinks}>
        <CustomContent value={content} />
      </div>
    </>
  );
}
